export const size = {
    mobile: '320px',
    laptop: '1024px',
  }

export const device = {
    mobile: `(min-width: ${size.mobile})`,
    laptop: `(min-width: ${size.laptop})`,
  };